export var ANNOTATION = 'annotation';
export var BLOCK = 'block';
export var CHANGE = 'change';
export var DECORATION = 'decoration';
export var DOCUMENT = 'document';
export var EDITOR = 'editor';
export var INLINE = 'inline';
export var MARK = 'mark';
export var OPERATION = 'operation';
export var POINT = 'point';
export var RANGE = 'range';
export var SELECTION = 'selection';
export var TEXT = 'text';
export var VALUE = 'value';